import React from 'react'
import Resume from '../Assets/Resume.txt'
const Cvbtn = ({value}) => {
  return (
    <div>
      <a href={Resume} download="Myresume" target='-blank'>
      <button className={`capitalize w-44 h-12 text-center rounded-3xl border-2   
      ${value?`border-red bg-red mt-5`:`text-whatcvbtn border-whatcvbtn m-auto`}`}>download cv</button>
      </a>  
    </div>
  )
}
export default Cvbtn

